import moment from "moment";
import React from "react";
import {
  getWeekColumnData,
  isCurrentWeek,
} from "../../../../../utils/annual-planner-helpers";

// Replaces MonthCard's day-picker (a real day-by-day mini calendar) for
// Periodization specifically - PRD 7.7/7.8 describe weeks as columns with a
// single "week-of" date header, not a day grid. MonthCard/react-day-picker
// stays as-is for the other consumer of MonthColumn.js (the nutrition
// plans page's year-grid, isAnnualPlanner=false), which still wants real
// days. See ~/.claude/plans/periodization-calendar-view-redesign.md.
//
// Dropping the day-picker also drops its day-range drag-select (used to
// pre-fill the Add Event modal's dates) - confirmed against the PRD, which
// describes this header as a week selector only (7.8), never a date-range
// picker. Not preserved in any form here.
export const WeekOfRow = ({
  month,
  startingCalendarDay,
  numberOfWeeks,
  selectedWeek,
  onSelectWeek,
}) => (
  <div className="week-of-row">
    <h2 className="month-title">{moment(month).format("MMM YYYY")}</h2>
    <div className="week-of-dates">
      {Array.from({ length: numberOfWeeks }, (_, weekNumber) => {
        const weekFirstDay = getWeekColumnData(
          month,
          startingCalendarDay,
          weekNumber
        );
        const isOutsideMonth = weekFirstDay.month() !== moment(month).month();
        const isSelected =
          selectedWeek && moment(weekFirstDay).isSame(selectedWeek, "day");

        return (
          <div
            key={weekFirstDay.format("YYYYMMDD")}
            className={`week-of-date-slot${isCurrentWeek(weekFirstDay) ? " current-week" : ""}`}
          >
            <button
              type="button"
              className={`week-of-date${isOutsideMonth ? " outside" : ""}${
                isSelected ? " selected" : ""
              }`}
              onClick={() => onSelectWeek(weekFirstDay)}
            >
              {weekFirstDay.format("D")}
            </button>
          </div>
        );
      })}
    </div>
  </div>
);
